import React, { useEffect, useState } from "react"
import { Card, CardBody, Col, Nav, NavLink, Row, TabContent, TabPane } from "reactstrap"
import { change, FormSection, initialize, reduxForm } from "redux-form"
import { FORM_NAMES } from "constants/index"
import { connect } from "react-redux"
import validate from "./eventInfoValidation"
import {
  addEventInfo,
  getEventInfo,
  getRsvpBookedSpots,
  getRsvpWebpageConfig,
  resetEventInfo,
  updateEventInfo,
} from "store/actions"
import { mapApiToEventInfoForm, mapEventInfoToApi } from "../utils"
import PropTypes from "prop-types"
import EventInfoTab from "./eventInfoTab"
import WebpageSetupTab from "./webpageSetupTab"
import MenuFeatureHyperlinks from "../menuFeatureHyperlinks"
import { LoadingIndicator } from "components/LoadingIndicator"
import ModalComponent from "components/Modals"
import { SaveButton } from "components/Buttons"

let EventInfo = props => {
  const TABS = {
    EVENT_INFO: 1,
    WEBPAGE_SETUP: 2,
    HYPERLINKS: 3,
  }
  const [activeTab, setActiveTab] = useState(TABS.EVENT_INFO)
  const [notificationModalIsOpen, setNotificationModalIsOpen] = useState(false)
  const [publishProps, setPublishProps] = useState(null)

  const markAsActive = tab => {
    return activeTab === tab ? "active" : ""
  }
  const moment = require("moment-timezone")

  useEffect(() => {
    if (props.feature.entity_id) {
      props.getEventInfo(props.feature.entity_id)
    }
    return () => {
      props.resetEventInfo()
    }
  }, [])

  useEffect(() => {
    if (props?.selectedEvent) {
      props.getRsvpBookedSpots({ event_id: props.selectedEvent.id })
      props.getRsvpWebpageConfig({ id: props.selectedEvent.id })
    }
  }, [props.selectedEvent])

  useEffect(() => {
    if (props.eventInfo) {
      props.initializeForm(mapApiToEventInfoForm(props.eventInfo))
    }
  }, [props.eventInfo, props?.rsvpBookedSpots, props?.rsvpWebpageConfig])

  const handleEventInfoSubmit = data => {
    if (!props.eventInfo) {
      props.addEventInfo(
        mapEventInfoToApi({
          ...data.event_info_form,
          timezone: moment.tz.guess(),
          vendorId: props.vendorId,
          menu_item_id: props.feature.id,
          event_id: props.selectedEvent ? props.selectedEvent.id : null,
        })
      )
    } else {
      const paramsData = {
        ...props.eventInfo,
        ...mapEventInfoToApi({
          ...data.event_info_form,
          timezone: moment.tz.guess(),
          vendorId: props.vendorId,
          menu_item_id: props.feature.id,
          event_id: props.selectedEvent ? props.selectedEvent.id : null,
        }),
      }
      if (props?.isEventFeature) {
        if (props.selectedEvent?.published) {
          setPublishProps(paramsData)
          setNotificationModalIsOpen(true)
        } else {
          props.updateEventInfo(paramsData)
        }
      } else {
        props.updateEventInfo(paramsData)
      }
    }
  }

  return (
    <React.Fragment>
      {props?.loading ? (
        <LoadingIndicator />
      ) : (
        <Card>
          <CardBody className="shadow-sm p-1">
            <Nav tabs pills>
              <NavLink
                className={markAsActive(TABS.EVENT_INFO)}
                onClick={() => setActiveTab(TABS.EVENT_INFO)}
              >
                Event Info
              </NavLink>
              <NavLink
                className={markAsActive(TABS.WEBPAGE_SETUP)}
                onClick={() => setActiveTab(TABS.WEBPAGE_SETUP)}
              >
                Webpage Setup
              </NavLink>
              {props?.isEventFeature &&
                (!!props?.vendorConfig?.nfc_hyperlinks ||
                  !!props?.vendorConfig?.communication_hyperlinks) && (
                  <NavLink
                    className={markAsActive(TABS.HYPERLINKS)}
                    onClick={() => setActiveTab(TABS.HYPERLINKS)}
                  >
                    Hyperlinks
                  </NavLink>
                )}
            </Nav>
            <TabContent activeTab={activeTab}>
              <TabPane tabId={TABS.EVENT_INFO} style={{ animation: "none" }}>
                <FormSection name={props?.form}>
                  <EventInfoTab
                    feature={props?.feature}
                    saveHandler={props.handleSubmit(handleEventInfoSubmit)}
                    design={props.design}
                  />
                </FormSection>
              </TabPane>
              <TabPane tabId={TABS.WEBPAGE_SETUP} style={{ animation: "none" }}>
                <FormSection name={"webpage_setup"}>
                  <WebpageSetupTab />
                </FormSection>
              </TabPane>
              {props?.isEventFeature &&
                (!!props?.vendorConfig?.nfc_hyperlinks ||
                  !!props?.vendorConfig?.communication_hyperlinks) && (
                  <TabPane
                    tabId={TABS.HYPERLINKS}
                    style={{ animation: "none" }}
                  >
                    <MenuFeatureHyperlinks
                      event_id={props?.selectedEvent?.id}
                      menu_feature={props?.feature}
                    />
                  </TabPane>
                )}
            </TabContent>
          </CardBody>
        </Card>
      )}
      <ModalComponent
        open={notificationModalIsOpen}
        onClose={() => setNotificationModalIsOpen(false)}
      >
        <Row>
          <h5>
            Would you like to send a notification to your users that the event
            info has been updated?
          </h5>
        </Row>
        <Row className="mt-3 d-flex justify-content-end">
          <Col xs="auto">
            <SaveButton
              type="button"
              content="No"
              onClick={() => {
                if (publishProps) {
                  props.updateEventInfo(publishProps)
                }
                setNotificationModalIsOpen(false)
              }}
            />
          </Col>
          <Col xs="auto">
            <SaveButton
              type="button"
              content="Yes"
              onClick={() => {
                if (publishProps) {
                  props.updateEventInfo({
                    ...publishProps,
                    send_notification: true,
                  })
                }
                setNotificationModalIsOpen(false)
              }}
            />
          </Col>
        </Row>
      </ModalComponent>
    </React.Fragment>
  )
}

EventInfo = reduxForm({
  form: FORM_NAMES.EVENT_INFO,
  validate,
  initialValues: {
    event_info_form: {
      rsvpOption: "0",
      startTimeType: "AM",
      endTimeType: "AM",
    },
  },
})(EventInfo)

const mapStateToProps = state => ({
  eventInfo: state.EventInfo.eventInfo,
  loading: state.EventInfo.loading,
  rsvpBookedSpots: state.EventInfo.rsvpBookedSpots,
  vendorId: state.Login.vendorId,
  selectedEvent: state.experiences.selectedEvent,
  rsvpWebpageConfig: state.EventInfo.rsvpWebpageConfig,
  vendorConfig: state.clients.vendorConfig,
})

const mapDispatchToProps = dispatch => ({
  getEventInfo: value => dispatch(getEventInfo(value)),
  resetEventInfo: () => dispatch(resetEventInfo()),
  initializeForm: values =>
    dispatch(initialize(FORM_NAMES.EVENT_INFO, { event_info_form: values })),
  changeField: (field, value) =>
    dispatch(change(FORM_NAMES.EVENT_INFO, field, value)),
  addEventInfo: values => dispatch(addEventInfo(values)),
  updateEventInfo: values => dispatch(updateEventInfo(values)),
  getRsvpBookedSpots: values => dispatch(getRsvpBookedSpots(values)),
  getRsvpWebpageConfig: values => dispatch(getRsvpWebpageConfig(values)),
})

EventInfo.propTypes = {
  feature: PropTypes.object,
}

export default connect(mapStateToProps, mapDispatchToProps)(EventInfo)
